<template>
  <div>
    <el-button
      type="take-photo"
      @click="activateCamera"
      v-show="!webcamActive"
      :class="[{[`loaded-${side}`]: isLoaded}, {'show-webcam': webcamActive}]"
    >
      {{ !isLoaded ? $t('preCheckIn.uploadPhoto.takePhoto') : $t('preCheckIn.uploadPhoto.reTakePhoto') }}
    </el-button>
    <div
      class="video-wrap"
      v-show="webcamActive"
    >
      <el-row
        class="webcam-container"
      >
        <el-row
          class="frame-overlay"
          ref="frameOverlay"
          v-show="!photoTaken && isWebcamLoaded"
        >
          <div class="corners">
            <div class="corner top-left" />
            <div class="corner top-right" />
            <div class="corner bottom-right" />
            <div class="corner bottom-left" />
          </div>
        </el-row>
        <video
          :ref="`${side}Video`"
          :class="['webcam-video', side]"
          v-show="!photoTaken"
          autoplay
          muted
          playsinline
        />
        <canvas
          ref="canvas"
          style="display: none;"
        />
      </el-row>
    </div>
    <el-button
      @click="takePhoto"
      class="capture"
      v-show="webcamActive"
    >
      {{ !photoTaken ? $t('preCheckIn.uploadPhoto.takeThisPhoto') : $t('preCheckIn.uploadPhoto.takePhoto') }}
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    side: String,
    isLoaded: Boolean,
    webcamActive: Boolean,
    photoTaken: Boolean,
    isWebcamLoaded: Boolean
  },
  methods: {
    activateCamera() {
      this.$emit('activateCamera', this.side);
    },
    takePhoto() {
      this.$emit('takePhoto', this.side);
    }
  }
};
</script>